import { PriceTypeEnum, SelectionStatus } from '@mitsubishi/shared/data-access';

export enum ExportSelectionUnitsEnum {
  ALL = 'ALL',
  SPECIAL_UNITS = 'SPECIAL_UNITS',
  SPECIAL_ACCESSORIES = 'SPECIAL_ACCESSORIES',
}

export interface ExportProjectsDataRequest {
  organizationId: number;
  selectionStatuses: SelectionStatus[];
  selectionCreationDateFrom: string | null;
  selectionCreationDateTo: string | null;
  selectionLastRevisionDateFrom: string | null;
  selectionLastRevisionDateTo: string | null;
  sapFamilyCodes: string[];
  unitType: ExportSelectionUnitsEnum;
  families: number[];
  classes: number[];
  subClasses: number[];
  subfamilies: number[];
  /** APPLYMESD-2342: the price level of the exported prices. */
  priceType: PriceTypeEnum;
  /** APPLYMESD-2342: only the selections in this currency. */
  currencyCode: string;
}

export type ExportSelectionHistoryFamily = { familyId: number; familyCode: string };
export type ExportSelectionHistorySubFamily = { subfamilyId: number; subfamilyCode: string };

export interface ExportSelectionHistory {
  createdBy: number;
  createdAt: number;
  organizationId: number;
  selectionStatuses: SelectionStatus[];
  selectionCreationDateFrom: number;
  selectionCreationDateTo: number;
  selectionLastRevisionDateFrom: number | null;
  selectionLastRevisionDateTo: number | null;
  sapFamilyCodes: string[];
  unitType: ExportSelectionUnitsEnum;
  classes: number[];
  subClasses: number[];
  subfamilies: ExportSelectionHistorySubFamily[];
  families: ExportSelectionHistoryFamily[];
  /** Null on the filters saved before APPLYMESD-2342. */
  priceType: PriceTypeEnum | null;
  currencyCode: string | null;
}
